
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 480 480"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M460.056 209.104a8 8 0 00-7.936-.096l-22.016 12.232L424 7.776A8 8 0 00416 0h-56a8 8 0 00-8 7.776L344.544 268.8 320 282.4V216a8 8 0 00-11.88-6.992L176 282.4V216a8 8 0 00-11.88-6.992l-144 80A8 8 0 0016 296v176a8 8 0 008 8h432a8 8 0 008-8V216a8 8 0 00-3.944-6.896zM367.776 16h40.448l.464 16H367.32l.456-16zm-.92 32h42.288l5.2 181.992-53.544 29.736L366.856 48zM232 464h-48v-40h48v40zm64 0h-48v-40h48v40zm152 0H312v-48a8 8 0 00-8-8H176a8 8 0 00-8 8v48H32V300.712L160 229.6V296a8 8 0 0011.88 6.992L304 229.6V296a8 8 0 0011.88 6.992l75.448-41.912L426.4 241.6l21.6-12V464z"}}),_c('path',{attrs:{"d":"M128 320H64a8 8 0 00-8 8v32a8 8 0 008 8h64a8 8 0 008-8v-32a8 8 0 00-8-8zm-8 32H72v-16h48v16zM272 320h-64a8 8 0 00-8 8v32a8 8 0 008 8h64a8 8 0 008-8v-32a8 8 0 00-8-8zm-8 32h-48v-16h48v16zM416 320h-64a8 8 0 00-8 8v32a8 8 0 008 8h64a8 8 0 008-8v-32a8 8 0 00-8-8zm-8 32h-48v-16h48v16z"}})])
          )
        }
      }
    